import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialWatchTime: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.145 22.86v-4.58h1.52v-4.57h-1.52V9.14h-1.53v13.72zm-18.29 0v1.52H9.9V32h10.67v-7.62h3.04v-1.52Zm12.19 7.62h-7.62v-1.53h7.62Zm0-3.05h-7.62V25.9h7.62ZM9.9 10.67v1.52H8.385v7.62H9.9v1.52h10.67v-1.52h1.53v-7.62h-1.52v-1.52Zm1.52 3.04h1.53v1.53h-1.53Zm7.62 4.57h-1.52v1.53h-4.57v-1.53h-1.53v-1.52h1.53v1.52h4.57v-1.52h1.52Zm0-3.04h-1.52v-1.53h1.52ZM9.9 0v7.62H6.855v1.52h16.76V7.62h-3.04V0Zm9.14 6.09h-7.62V4.57h7.62Zm0-3.04h-7.62V1.52h7.62ZM5.335 9.14h1.52v13.72h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialWatchTime
